import { actions, getters } from "@/constants/state";
import store from "@/store";

export default async (to, from, next) => {
  try {
    await store.dispatch(
      actions.SHIFT_REQUESTS_FETCH_PENDING_ACTION,
      store.getters[getters.DOMAIN_LOCATION_ID_GETTER]
    );
    store.dispatch(actions.SHIFT_REQUESTS_FETCH_HISTORY_ACTION, {
      showLastYear: 0,
    });
  } catch (error) {
    console.error("Shift request overview resolver", error);
  }

  next();
};
